import React , {useRef} from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faAt ,faCocktail,  faMapMarkerAlt,  faPlus} from '@fortawesome/free-solid-svg-icons'


const NavFooter = () => {

    const refMenu = useRef()
   

    const allLi = [


        // {
        //     id: {'--i':0},
        //     icon: faAt,
        //     location: 'maitto:email@exemple.com'
        // },
        {
            id: {'--i':1},
            icon: faMapMarkerAlt,
            location:'/map'
        },
        {
            id: {'--i':2},
            icon: faCocktail,
            location:'/carte'
        },
        {
            id: {'--i':3},
            icon: faAt,
            location:'mailto:lessentielcocktailbar@gmail.com'
        },
        // {
        //     id: {'--i':4},
        //     icon: faPhone,
        //     location:'tel:+33627523597'
        // },
        
       
       
    ]

    
    

    const handleClick = () => {

        refMenu?.current?.classList.toggle('active')

    }


    return (
      <>
        <Nav>
            <ul className='menu' ref={refMenu}>
                {
                 allLi.map((item,key) => {
                     return (
                           <li key={key} style={item.id}><a href={item.location}><FontAwesomeIcon icon={item.icon} size='xs'/></a></li>
                
                     )
                 })
                }
             

           
            <span className='toggle'  onClick={handleClick}>

                <FontAwesomeIcon icon={faPlus} size='xs' />
            </span>
        </ul>
        </Nav>
     </>
    );
};

const Nav = styled.div`

display:flex;
justify-content: center;
align-items:center;
position:absolute;
z-index:0;

left: 50%;
transform: translateX(-50%);
bottom:-50%;
font-size: 52px;

color: #f9f9f9;



span{
   
    display:flex;
    justify-content: center;
    align-items: center;
   
}

.menu{
    list-style:none;
    display:flex;
    justify-content: center;
    align-items:center;
    width: 200px;
    height: 100px;
    z-index:-9999;
    
    position:relative;
    top:-40px;
   
    
    li{
        position:absolute;
        bottom:43%;        
        border-radius: 50%;
        font-size: 33px;
        display:flex;
        justify-content: center;
        align-items:center;        
        height:36px;
        width:36px;
        transition: 0.5s;
        left:0;
        transition-delay: calc(0.1s * var(--i));
        background-color: rgb(159, 220, 150);
        box-shadow: 0px 0px 5px 5px rgb( 0, 0, 0 , 0.5);
        z-index:3;
        
        transform-origin: 100px;
        transform: rotate(0deg) translateX(50px) scale(0.5);

       

        a{
         color:#f9f9f9;
        }
       
      
        
        
      


    }
}

.toggle{
    position: absolute;
    z-index:999;
    width: 60px;
    height: 60px;
    background-color: rgb(159, 220, 150);
    border-radius: 50%;
    box-shadow: 0px 0px 5px 5px rgb(0,0,0,0.3);
    cursor: pointer;
    transition: 1.25s;


}

.menu.active .toggle{
    
    transform: rotate(315deg);
    
}

.menu.active li {


    
    
    transform: rotate(calc(360deg / 8 * var(--i))) scale(1.3);
    transition: 300ms ease-in-out;

    

    a{
        width: 50px;
        height: 50px;
        background-color: transparent;
        cursor:pointer;
        font-size: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration:none;
        color: #f9f9f9;
        transform: rotate(calc(360deg / -8 * var(--i)));

    }
    
}



@media (min-width: 1200px){
display:none;
}



`

export default NavFooter;